/** @format */

import apiSlice from './api-slice';

// apiSlice.enhanceEndpoints({
//    addTagTypes: ['User'],
// });
export const carBrandApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCarBrands: builder.query({
      query: (params) => ({
        url: '/car/brand/all',
        method: 'GET',
        params: params
      }),
      providesTags: ['CarBrand']
    }),

    getCarBrandListOptions: builder.query({
      query: (params) => ({
        url: '/car/brand/options',
        method: 'GET',
        params: params
      }),
      providesTags: ['CarBrandOptions']
    }),

    createBrand: builder.mutation({
      query: (params) => ({
        url: '/car/brand',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['CarBrand']
    }),
    updateBrand: builder.mutation({
      query: ({ id, formData, ...params }) => {
        const body = formData ? formData : params;
        return {
          url: `/car/brand/${id}`,
          method: 'PATCH',
          body: body
        };
      },
      providesTags: ['CarBrand']
    }),
    deleteBrand: builder.mutation({
      query: (id) => {
        return {
          url: `/car/brand/${id}`,
          method: 'DELETE'
        };
      },
      providesTags: ['CarBrand']
    })
  })
});

export const {
  useGetCarBrandsQuery,
  useUpdateBrandMutation,
  useCreateBrandMutation,
  useDeleteBrandMutation,
  useGetCarBrandListOptionsQuery
} = carBrandApi;
